import { render, staticRenderFns } from "./addMember.vue?vue&type=template&id=81cf2f4a&scoped=true&lang=html&"
import script from "./addMember.vue?vue&type=script&lang=ts&"
export * from "./addMember.vue?vue&type=script&lang=ts&"
import style0 from "./addMember.vue?vue&type=style&index=0&id=81cf2f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cf2f4a",
  null
  
)

export default component.exports